import { ReceiptDetailPanelVariant } from "./shared/ReceiptDetailPanelVariant";
import newProduct from "./images/newProduct.png";
import { receiptDetailExamplesToom } from "./ReceiptDetailExamplesToom";

export const ReceiptDetailPanelToom = () => (
  <ReceiptDetailPanelVariant
    examples={receiptDetailExamplesToom}
    imageFolder="productImagesToom"
    badgeIcon={newProduct}
    badgeAlt="Bio-zertifiziert"
    badgeTitle="Bio-zertifiziert"
    colStyle={{ marginBottom: "20px" }}
    buttonStyle={{ width: "100%", height: "100%" }}
    toastStyle={{ height: "100%", display: "flex", flexDirection: "column" }}
    toastHeaderStyle={{ minHeight: "60px", alignItems: "flex-start" }}
  />
);
